<!-- eslint-disable vue/no-v-html -->
<template>
  <b-modal
    id="modal-invoice-preview"
    ref="refModal"
    title="Chi tiết hóa đơn"
    hide-footer
    size="lg"
    scrollable
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    @show="showModal"
    @hidden="resetModal"
  >
    <!-- Body -->

    <div v-if="(pdfUrl || draftInvoice) " class="mt-50">
      <b-button :disabled="!(item.oldShuttles === item.total)" class="ml-50" variant="success" @click="issueViettelInvoice"> Phát hành hóa đơn điện tử</b-button>
      <b-button
        v-if="itemLocal.remain !== 0 && $can('pay', 'invoice')"
        class="ml-50"
        variant="warning"
        @click="$emit('pay-invoice')"
      >
        <feather-icon icon="CreditCardIcon" class="mr-50" />
        <span class="align-middle">Thu tiền</span>
      </b-button>
      <b-button
        v-if="!itemLocal.approve && $can('approve', 'invoice')"
        variant="info"
        class="ml-50"
        @click="$emit('approve-invoice')"
      >
        <feather-icon icon="CheckSquareIcon" class="mr-50" />
        <span class="align-middle">Duyệt</span>
      </b-button>
    </div>

    <div class="d-flex justify-content-center my-1">
      <b-spinner v-if="isLoading" class="text-center" variant="secondary" />
    </div>

    <iframe v-if="(pdfUrl || draftInvoice) && !isLoading" :src="viewDraftInvoice == true && draftInvoice
        ? `data:application/pdf;base64,${draftInvoice}`
        : pdfUrl
      " style="width: 100%; height: 80vh; border: none" />
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
import { required } from "@validations";
import useInvoicePreviewModal from "./useInvoicePreviewModal";

export default {
  components: {
    BModal,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    viettel: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      required,
    };
  },
  setup(props) {
    const {
      itemLocal,
      resetItemLocal,
      resetModal,
      fetchInvoiceHtml,
      showModal,
      downloadInvoicePDF,
      downloadInvoiceImage,
      sendInvoiceViaZaloZNS,
      sendInvoiceViaZaloNormal,
      sendInvoiceViaEmail,
      sendInvoiceViaApp,
      sendInvoiceViaZaloOA,
      getViettelInvoiceDraft,
      viewInvoiceTingeEdu,
      copyPreviewLink,
      pdfUrl,
      isLoading,
      previewUrl,
      draftInvoice,
      viewDraftInvoice,
      issueViettelInvoice,
    } = useInvoicePreviewModal(props);

    return {
      itemLocal,
      resetItemLocal,
      resetModal,
      fetchInvoiceHtml,
      showModal,
      downloadInvoicePDF,
      downloadInvoiceImage,
      sendInvoiceViaZaloZNS,
      sendInvoiceViaZaloNormal,
      sendInvoiceViaEmail,
      sendInvoiceViaApp,
      getViettelInvoiceDraft,
      viewInvoiceTingeEdu,
      issueViettelInvoice,
      sendInvoiceViaZaloOA,
      copyPreviewLink,
      pdfUrl,
      isLoading,
      previewUrl,
      draftInvoice,
      viewDraftInvoice,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
.vgt-wrap {
  .vgt-table {
    thead {
      th {
        font-size: 1rem !important;
        font-weight: 500;
      }
    }
    td {
      font-size: 1rem !important;
      font-weight: 500;
    }
  }
}
</style>
